import { ReactNode } from 'react'
import { Stack, StackProps, SvgIcon } from '@mui/material'

export const featureIconSizeMap = {
  small: {
    iconCircleRadius: 40,
    iconSize: 20,
  },
  medium: {
    iconCircleRadius: 48,
    iconSize: 24,
  },
  large: {
    iconCircleRadius: 64,
    iconSize: 32,
  },
}

export type CenterDiscProps = {
  /** Diameter in px */
  size: 'small' | 'medium' | 'large'
  icon: ReactNode
} & Omit<StackProps, 'children'>

export const FeatureIcon = ({ size, icon, sx, ...rest }: CenterDiscProps) => {
  const { iconCircleRadius, iconSize } = featureIconSizeMap[size]
  return (
    <Stack
      sx={{
        width: iconCircleRadius,
        height: iconCircleRadius,
        borderRadius: 200,
        backgroundColor: (t) => t.palette.action.selected,
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative', // Ensure z-index works if needed
        zIndex: 1, // Sit above radar rings if they are in same context
        ...sx,
      }}
      {...rest}
    >
      <SvgIcon sx={{ width: iconSize, height: iconSize }}>{icon}</SvgIcon>
    </Stack>
  )
}
